import classNames from 'classnames'
import HourlyMonthlyRate from './HourlyMonthlyRate'
import EventRate from './EventRate'

const RateList = ({
    event,
    rates = [],
    selectedRateId,
    disabled,
    selectRate,
    discountedRateId,
    promoCodeDiscount,
    waitingList = false,
}) => {
    const Rate = event ? EventRate : HourlyMonthlyRate
    const ratesList = event ? rates : rates.sort((a, b) => (a.amount >= b.amount ? 1 : -1))

    return (
        <ul className={classNames('booking__rate-list', { disabled })}>
            {ratesList.map((rate, i) => (
                <Rate
                    rate={rate}
                    key={i}
                    disabled={disabled}
                    selectRate={selectRate}
                    isActive={rates.length === 1}
                    discountedRateId={discountedRateId}
                    promoCodeDiscount={promoCodeDiscount}
                    selectedRateId={selectedRateId}
                    waitingList={waitingList}
                />
            ))}
        </ul>
    )
}

export default RateList
